import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#input-number" }),
    /*#__PURE__*/_createTextVNode(" InputNumber ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Input numerical values with a customizable range. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIDisabled = _resolveComponent("EUIDisabled")
  const _component_EUISteps = _resolveComponent("EUISteps")
  const _component_EUIStepStrictly = _resolveComponent("EUIStepStrictly")
  const _component_EUIPrecision = _resolveComponent("EUIPrecision")
  const _component_EUISize = _resolveComponent("EUISize")
  const _component_EUIControlsPosition = _resolveComponent("EUIControlsPosition")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIDisabled),
    _createVNode(_component_EUISteps),
    _createVNode(_component_EUIStepStrictly),
    _createVNode(_component_EUIPrecision),
    _createVNode(_component_EUISize),
    _createVNode(_component_EUIControlsPosition)
  ], 64))
}